import './modal-rate-quote'

import {
  cleanNumberRegex,
  currencyFormat,
  calculateMonthlyPayment,
  calculateTotalLoanInterest,
  formatCalculatorValue,
  updateFormattedInputSelection,
} from './utils'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default (function() {

  /* eslint-disable no-unused-vars */
  var refiCalc = document.querySelector('.js-refinance-calculator');
  var submit = document.querySelector('.js-btn-calculate')

  function init() {

    if (!refiCalc) {
      return;
    }

    let ctaBanner = document.querySelector('.calculator-cta-banner')
    if (ctaBanner) {
      ScrollTrigger.create({
        trigger: ".js-cta-banner-trigger",
        start: "bottom top",
        onEnter: self => {
          ctaBanner.classList.add('active')
        },
        onLeaveBack: self => {
          ctaBanner.classList.remove('active')
        }
      });
    }

    const handleInputMouseUp = (event) => {
      event.target.removeEventListener('mouseup', handleInputMouseUp)
      event.target.removeEventListener('keyup', handleInputMouseUp)
      updateFormattedInputSelection(event.target)
    }

    // submit.addEventListener('click', function() {
    //   runCalculation()
    // });

    var inputs = document.querySelectorAll('input[type="text"]');
    inputs.forEach(function(input) {

      input.addEventListener('input', function(event) {
        runCalculation()
      });

      input.addEventListener('blur', function(event) {

        let format = event.target.dataset.format
        if (!format) {
          return;
        }

        let formattedValue = formatCalculatorValue(event.target.value, format)
        event.target.value = formattedValue
      });

      // On focus, switch to using just numeric value
      input.addEventListener('focus', (event) => {
        event.target.addEventListener('mouseup', handleInputMouseUp)
        event.target.addEventListener('keyup', handleInputMouseUp)
      })
    });

    function runCalculation() {

      var bannerMontlyPayment = document.querySelector('.monthly-payment-amount')

      var existingBalance = parseFloat(document.querySelector('.existing-balance').value.replace(cleanNumberRegex, '')) || 0;
      var existingYearsLeft = parseFloat(document.querySelector('.existing-years-left').value) || 1;
      var existingYearsLeftAsMonths = existingYearsLeft * 12
      var existInterestRate = (parseFloat(document.querySelector('.existing-interest-rate').value) || 1) / 12 / 100;
      // var existingHazardInsurance = parseFloat(document.querySelector('.existing-hazard-insurance').value.replace(cleanNumberRegex, '')) || 0
      // var existingMortgageInsurance = parseFloat(document.querySelector('.existing-mortgage-insurance').value.replace(cleanNumberRegex, '')) || 0
      // var existingPropertyTaxes = parseFloat(document.querySelector('.existing-property-taxes').value.replace(cleanNumberRegex, '')) || 0

      var newLoanAmountInput = document.querySelector('.new-loan-amount')
      var newLoanAmount = parseFloat(newLoanAmountInput.value.replace(cleanNumberRegex, '')) || 0
      var newHomeValue = parseFloat(document.querySelector('.new-home-value').value.replace(cleanNumberRegex, '')) || 0;
      var newCashAmount = parseFloat(document.querySelector('.new-cash-amount').value.replace(cleanNumberRegex, ''));
      var newMortgagePeriod = parseFloat(document.querySelector('.new-mortgage-period').value.replace(cleanNumberRegex, '')) || 1;
      var newMortgagePeriodAsMonths = newMortgagePeriod * 12
      var newInterestRate = parseFloat(document.querySelector('.new-interest-rate').value.replace(cleanNumberRegex, '')) / 12 / 100;
      // var newHazardInsurance = parseFloat(document.querySelector('.new-hazard-insurance').value.replace(cleanNumberRegex, '')) || 0
      // var newMortgageInsurance = parseFloat(document.querySelector('.new-mortgage-insurance').value.replace(cleanNumberRegex, '')) || 0
      // var newPropertyTaxes = parseFloat(document.querySelector('.new-property-taxes').value.replace(cleanNumberRegex, '')) || 0

      newLoanAmount += newCashAmount

      let existingPrincipalAndInterest = calculateMonthlyPayment(existingBalance, existInterestRate, existingYearsLeftAsMonths)
      let existingMonthlyPayment = existingPrincipalAndInterest

      let newPrincipalAndInterest = calculateMonthlyPayment(newLoanAmount, newInterestRate, newMortgagePeriodAsMonths)
      let newMonthlyPayment = newPrincipalAndInterest


      var monthlySavings = parseInt(existingMonthlyPayment - newMonthlyPayment)

      let currentTotalInterest = calculateTotalLoanInterest(existingBalance, existInterestRate, existingYearsLeftAsMonths)
      let newTotalInterest = calculateTotalLoanInterest(newLoanAmount, newInterestRate, newMortgagePeriodAsMonths)

      let totalCurrentLoan = existingBalance + currentTotalInterest
      let totalNewLoan = newLoanAmount + newTotalInterest

      let mortgagePayoff = Math.abs(newMortgagePeriod - existingYearsLeft)

      document.querySelector('.results-current-payment').innerHTML = currencyFormat.format(Math.max(0, existingMonthlyPayment))
      document.querySelector('.results-new-payment').innerHTML = currencyFormat.format(Math.max(0, newMonthlyPayment))

      document.querySelector('.results-current-interest').innerHTML = currencyFormat.format(Math.max(0, currentTotalInterest));
      document.querySelector('.results-new-interest').innerHTML = currencyFormat.format(Math.max(0, newTotalInterest));

      document.querySelector('.results-current-total').innerHTML = currencyFormat.format(Math.max(0, totalCurrentLoan));
      document.querySelector('.results-new-total').innerHTML = currencyFormat.format(Math.max(0, totalNewLoan));

      document.querySelector('.results-interest-savings').innerHTML = currencyFormat.format(Math.max(0, currentTotalInterest - newTotalInterest));
      document.querySelector('.results-total-savings').innerHTML = currencyFormat.format(Math.max(0, totalCurrentLoan - totalNewLoan));
      document.querySelector('.results-mortgage-payoff').innerHTML = `${ existingYearsLeft > newMortgagePeriod ? '-' : '+' }${ mortgagePayoff } years`;
      document.querySelector('.results-cash-at-closing').innerHTML = currencyFormat.format(newCashAmount);

      bannerMontlyPayment.innerHTML = currencyFormat.format(Math.max(0, newMonthlyPayment))
    }

    runCalculation();
  }

  return {
    init: init,
  }

  /* eslint-enable no-unused-vars */

})()
